import React, { useState } from 'react';
import Switch from '../../../../../../../Shared/Switch';
import { Control, UseFormSetValue, UseFormWatch } from 'react-hook-form';
import { EditableQuestion } from '../../../../../../types';
import MainQuestionEditor from './MainQuestionEditor';
import TriggeringAnswerEditor from './TriggeringAnswerEditor';
import { StyledQuestionFieldContainer } from '../../styles';
import { RootStateOrAny, useSelector } from 'react-redux';
import { selectPossibleParentQuestions } from '../../../../../../../../redux/questionnaire/selectors';
import { isFollowUpQuestion } from '../../../../../../../../redux/questionnaire/utils';
import { useFollowUpFieldsResetter } from './hooks/useFollowUpFieldsResetter';
import { useCurrentParentQuestionAnswers } from './hooks/useParentQuestionAnswers';

interface Props {
  question: EditableQuestion;
  control: Control<EditableQuestion>;
  watch: UseFormWatch<EditableQuestion>;
  setValue: UseFormSetValue<EditableQuestion>;
}

const FollowUpEditor = ({ question, control, watch, setValue }: Props) => {
  const [isEditingFollowUp, setIsEditingFollowUp] = useState(isFollowUpQuestion(question));

  const parentQuestionId = watch('parent_question_id');

  useFollowUpFieldsResetter(isEditingFollowUp, setValue);

  const questions = useSelector((state: RootStateOrAny) => selectPossibleParentQuestions(state, question._id));
  const parentQuestionAnswers = useCurrentParentQuestionAnswers(parentQuestionId);

  return (
    <StyledQuestionFieldContainer>
      <Switch
        label="Is follow up question"
        value={isEditingFollowUp}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setIsEditingFollowUp(e.target.checked)}
        checked={isEditingFollowUp}
        disabled={false}
        reverseOrder={false}
      />
      {isEditingFollowUp && <MainQuestionEditor control={control} mainQuestions={questions} />}
      {isEditingFollowUp && parentQuestionId && <TriggeringAnswerEditor control={control} answers={parentQuestionAnswers} />}
    </StyledQuestionFieldContainer>
  );
};
export default FollowUpEditor;
